
angular.module('app.services', [
  'app.services.alerts',
  'app.services.right_slide_mobile_menu',
  'app.services.session_service',
  'app.services.search',
  'app.services.squizsearch'
]);
